/**
 * Page size requested by the listing dialogs (`/creatives`, `/tags`): the API
 * maximum. The listings sort and filter client-side, which only reads true
 * over one complete page, so they take the largest page the API serves and
 * report `page.total` when it holds more.
 */
export const LISTING_PAGE_LIMIT = 1000

/** Rows the genre drill-down lists as its top tags. */
export const GENRE_TOP_TAGS_LIMIT = 15
